import React, { useState, useEffect } from "react";
import { AxiosCustomGet } from "../../../components/axios/AxiosCustom";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import Title from "../../../components/common/Title/Title";
import { initFilterInput, renderColumns } from "./constans";
import SwalToast from "../../../components/helpers/SwalToast";
import Config from "../../../components/axios/Config";
import Cookies from "js-cookie";
import CustomTable from "../../../components/common/Table/CustomTable";
import { Modal, Button, Input } from "antd";
import httpclient from "../../../components/httpclient";

export default function CompanySetting() {
  const [filterInput, setFilterInput] = useState(initFilterInput);
  const [records, setRecords] = useState();
  const [tablePagination, setTablePagination] = useState({});
  const [loading, setLoading] = useState(false);
  const [parameter, setParameter] = useState();
  const [modalEdit, setModalEdit] = useState(false);
  const [value, setValue] = useState();
  const [desc, setDesc] = useState();
  const [submitting, setSubmitting] = useState(false);
  const [type, setType] = useState();

  useEffect(() => {
    getData();
  }, [filterInput]);

  const getData = () => {
    setLoading(true);
    let params = {
      search: filterInput.search,
      page: parseInt(filterInput.page),
      page_size: parseInt(filterInput.pageSize),
    };
    let url = `${process.env.REACT_APP_BASE_API_URL}company-setting`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        params
      ),
      (response) => {
        setLoading(false);
        setRecords(response.data.data.items)
        setTablePagination({
          current: parseInt(response.data.data.page),
          pageSize: response.data.data.per_page,
          total: response.data.data.total_item,
        });
      },
      (error) => {
        setLoading(false);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleFilter = (e) => {
    const { value, name } = e.target;
    if (e.key === "Enter" || e.keyCode === 13) {
      setFilterInput((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleTableChange = (pagination) => {
    setFilterInput((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      pageSize: parseInt(pagination.pageSize),
    }));
  };

  const handleEdit = (record) => {
    console.log(record);
    setModalEdit(true);
    const { key, value, desc, type } = record;
    setParameter(key);
    setValue(value);
    setDesc(desc);
    setType(type);
  };

  const handleCloseModal = () => {
    setModalEdit(false);
    setParameter();
    setDesc();
    setValue();
    setType();
  };

  const handleSubmit = () => {
    setSubmitting(true);
    let data = {
      key: parameter,
      value: value,
    };
    console.log(data);

    let url = `${process.env.REACT_APP_BASE_API_URL}company-setting`;
    httpclient
      .PUT(url, data)
      .then((response) => {
        SwalToast.fire({
          icon: "success",
          title: response.data.message,
        });
        setModalEdit(false);
        getData();
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data.error);
          SwalToast.fire({
            icon: "error",
            title: error.response.data.error.message,
          });
        } else {
          console.log(error);
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };
  return (
    <div>
      <div className="px-3">
        <div className="py-4">
          <div className="d-flex flex-column" style={{ fontSize: "13px" }}>
            <Title text={"Company Setting"} />
            <Breadcrumb current={"Company Setting"} />
          </div>
        </div>
        <div className="d-flex pt-3 px-0">
          <div className="col-3 px-0">
            Parameter / Deskripsi :
            <input
              type="text"
              className="form-control form-control-lg border-97A0AE"
              placeholder="Cari parameter/kata kunci"
              name="search"
              onKeyDown={handleFilter}
              onChange={handleFilter}
            />
          </div>
        </div>
        <div style={{ marginTop: 24 }}>
          <CustomTable
            columns={renderColumns(handleEdit)}
            data={records}
            loading={loading}
            handleTableChange={handleTableChange}
            pagination={tablePagination}
          />
        </div>
      </div>
      <Modal
        className="modal-add"
        centered
        title={"Ubah Prameter"}
        visible={modalEdit}
        onOk={handleSubmit}
        onCancel={handleCloseModal}
        footer={[
          <Button
            onClick={handleCloseModal}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 36,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Kembali
          </Button>,
          <Button
            type="submit"
            disabled={submitting}
            onClick={handleSubmit}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 36,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            Simpan
          </Button>,
        ]}
      >
        <div style={{ display: "flex", marginTop: 24, alignItems: "center" }}>
          <div style={{ flex: 1 }}>
            <div style={{ color: "#A6A6A6" }}>Parameter :</div>
          </div>
          <div style={{ flex: 2 }}>
            <Input
              disabled
              style={{ height: 36 }}
              required
              type="text"
              className="form-control border-DCDCDC text-input"
              placeholder="Nama Juru Taksir"
              value={parameter}
              onChange={(e) => setParameter(e.target.value)}
            />
          </div>
        </div>
        <div style={{ display: "flex", marginTop: 12, alignItems: "center" }}>
          <div style={{ flex: 1 }}>
            <div style={{ color: "#A6A6A6" }}>Value :</div>
          </div>
          <div style={{ flex: 2 }}>
            <Input
              style={{ height: 36 }}
              required
              type="text"
              className="form-control border-DCDCDC text-input"
              placeholder="No. Telepon"
              value={value}
              onChange={(e) => setValue(e.target.value)}
            />
          </div>
        </div>
        <div style={{ display: "flex", marginTop: 12, alignItems: "center" }}>
          <div style={{ flex: 1 }}>
            <div style={{ color: "#A6A6A6" }}>Deskripsi :</div>
          </div>
          <div style={{ flex: 2 }}>
            <Input
              disabled
              style={{ height: 36 }}
              required
              type="text"
              className="form-control border-DCDCDC text-input"
              placeholder="Deskripsi"
              value={desc}
              onChange={(e) => setDesc(e.target.value)}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
}
